import React, { useState, useEffect } from "react";
import ChatWidget from "./ChatWidget";
import { auth, database } from "../firebase";

const ChatWrapper = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isEnabled, setIsEnabled] = useState(true); // Default to enabled

  // Listen for liveChatEnabled preference
  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      if (user) {
        const prefRef = database.ref(`/Owner/${user.uid}/Preferences/liveChatEnabled`);
        prefRef.on("value", (snap) => {
          // If not set, default to true (enabled)
          const val = snap.exists() ? !!snap.val() : true;
          setIsEnabled(val);
        });

        return () => prefRef.off();
      } else {
        // If not logged in, show chat by default
        setIsEnabled(true);
      }
    });

    return () => {
      if (typeof unsubscribeAuth === "function") unsubscribeAuth();
    };
  }, []);

  const toggleChat = () => {
    setIsVisible(!isVisible);
  };

  // Don't render if disabled
  if (!isEnabled) {
    return null;
  }

  return <ChatWidget isVisible={isVisible} onToggle={toggleChat} />;
};

export default ChatWrapper;
